import React, { useState, useEffect } from 'react';
import Card from "@mui/material/Card";
import { CardHeader } from '@mui/material';
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import SearchStringOrIntReq from '../../../../Classes/Models/Requests/SearchStringOrIntReq';
import AccountingApi from '../../../../Classes/API/AccountingApi';
import SetPostPaidReq from '../../../../Classes/Models/Requests/Accounting/SetPostPaidReq';
import Swal from 'sweetalert2';
import MDInput from 'components/MDInput';
import MDButton from 'components/MDButton';
const PostPaid = ({ Package, setIsLoaded }) => {
    const [postPaidPercentage, setPostPaidPercentageval] = useState(Package.postPaidPercentage);

    const SetPostPaidPercentage = async () => {
        Swal.fire({
            icon: 'info',
            title: 'Processing',
            text: 'Please wait...',
            didOpen: () => {
                Swal.showLoading();
            },
        });
        let req = new SetPostPaidReq();
        req.postPaidPercentage = postPaidPercentage;
        req.packageId = Package.id;
        let res = await AccountingApi.SetPackagePostPaidPercentage(req);
        if (res.status == "Success") {
            Swal.fire({
                icon: 'success',
                title: 'Success',
                text: res.message,
            });
            setIsLoaded(false);
        }
        else {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: res.message,
            });
        }
    }
    return (
        <Card sx={{ height: "100%", boxShadow: !false && "none", marginBottom: "2em",  }}>
            <CardHeader title={`Post Paid ${Package.postPaidPercentage}%`} />
            <MDBox sx={{ display: "flex", padding: "1em", justifyContent:"space-around", 
            borderBottom: "1px solid #e0e0e0", width:"80%", alignSelf:"center", marginBottom:"1em" }}>
                <MDInput label="Post Paid Percentage %" type="number"
                defaultValue={Package.postPaidPercentage} onChange={(e) => setPostPaidPercentageval(e.target.value)} />
                <MDButton variant="contained" color="primary" onClick={SetPostPaidPercentage}>
                    Save
                </MDButton>
            </MDBox>

            <MDBox sx={{ display: "flex", padding: "1em", justifyContent:"space-between",
            borderBottom: "1px solid #e0e0e0", width:"80%", alignSelf:"center", marginBottom:"1em" }}>
                <MDBox sx={{ display: "flex", flexDirection: "column", gap: "1em", textAlign:"center", 
                borderRadius: "1em", padding: "1em", boxShadow: "0 0 10px 0 rgba(0,0,0,0.2)"}}>
                    <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>{Package?.postPaidAmount}</MDTypography>
                    <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>Post Paid Amount</MDTypography>
                </MDBox>
                <MDBox sx={{ display: "flex", flexDirection: "column", gap: "1em", textAlign:"center",
                borderRadius: "1em", padding: "1em", boxShadow: "0 0 10px 0 rgba(0,0,0,0.2)"}}>
                    <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>{Package?.postPaidAmountDue}</MDTypography>
                    <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>Amount Due</MDTypography>
                </MDBox>
                <MDBox sx={{ display: "flex", flexDirection: "column", gap: "1em", textAlign:"center",
                borderRadius: "1em", padding: "1em", boxShadow: "0 0 10px 0 rgba(0,0,0,0.2)"}}>
                    <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>{Package?.postPaidAmountUsed}</MDTypography>
                    <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>Amount Used</MDTypography>
                </MDBox>
            </MDBox>
        </Card>
    )
}

export default PostPaid